/** Widget action prefixes shared by ChatWidget and merchant cart-help builders. */
export const CART_PRODUCT_HELP_PREFIX = '__cart_product_help__|';
export const CART_DISCOUNT_MENU_PREFIX = '__cart_discount_menu__|';
